// extracted by mini-css-extract-plugin
export default {"wrapper":"TailAnimation_wrapper__I-XDM","main_circle_box":"TailAnimation_main_circle_box__PU1mE","move":"TailAnimation_move__K-UJL","move2":"TailAnimation_move2__36lrK"};